import { GetContentsParams } from '@/api';
import Icon from '@/assets/icons/story.svg';
import { ClientAuth, Device, Logger } from '@/classes';
import { useRouter } from '@/hooks/useRouter';
import { ContentList } from '@/widgets/content-list';
import { Menu } from '@/widgets/menu';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const FairyTalesPage = () => {
  const router = useRouter();
  const { t } = useTranslation();

  const header = useMemo(
    () => (
      <>
        <img src={Icon} />
        <h1 className={`ml-3 text-[55px] text-[#000000] ${Device.language !== 'zh' && 'font-bold'}`}>
          {t('menu_story')}
        </h1>
      </>
    ),
    [t],
  );

  const params = useMemo<GetContentsParams>(
    () => ({
      type: 'VIDEO',
      category: 'FAIRYTALE',
      language: Device.language,
      resolution: 'P33',
    }),
    [],
  );

  useEffect(() => {
    if (!ClientAuth.user) {
      router.push('/login', { replace: true });
    }
  }, [router]);

  useEffect(() => {
    Logger.homeFairyTales();
  }, []);

  return (
    <div className="flex flex-col lg:flex-row h-screen">
      <Menu />
      <div className="flex flex-1 overflow-hidden">
        <ContentList
          sourcePage="fairy_tale"
          containerClassName="w-full h-screen overflow-x-hidden overflow-y-auto bg-[#F0FFFF]"
          headerClassName="pl-[52px] py-[16px] fixed flex items-center font-babyshark z-40 w-full bg-[#F0FFFF]"
          header={header}
          params={params}
        />
      </div>
    </div>
  );
};
